<div class="border-bottom border-dark-subtle z-max navbar-height-vplg ps-2 pe-2 background-white">
    <div class="row p-3 d-flex align-items-center">
        <div class="d-flex col">
            <a class="col-auto me-3 mt-auto mb-auto" href="https://moovement.co">
                <app-moovement-svg [colored]="true"></app-moovement-svg>
            </a>
            <app-nav-button (click)="!disabled() && toggleInformationCenter()"
                            [active]="informationCenterVisible()"
                            [disabled]="disabled()"
                            [icon]="'fa-solid fa-list fa-xl'"
                            class="col-auto me-2 mt-auto mb-auto"></app-nav-button>
            <app-nav-button (click)="!disabled() && toggleMap()"
                            [active]="mapVisible()"
                            [disabled]="disabled()"
                            [icon]="'fa-solid fa-map fa-xl'"
                            class="col-auto me-2 mt-auto mb-auto"></app-nav-button>
            <app-nav-button (click)="!disabled() && toggleNotifications()"
                            [active]="notificationsVisible()"
                            [disabled]="disabled()"
                            [icon]="'fa-solid fa-bell fa-xl'"
                            class="col-auto mt-auto mb-auto"></app-nav-button>
            <div class="col-auto mt-auto mb-auto max-width-700px">
                <app-search-bar></app-search-bar>
            </div>
        </div>
        <div class="col-auto ms-auto">
            <app-weather-widget></app-weather-widget>
        </div>
    </div>
</div>
